(function() { module.exports = this["wp"]["primitives"]; }());